import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DeletePendingPaymentsResponse } from '@/types/deletePendingPaymentsType';

type DeletePendingPaymentsParams = {
  oidLiquidacion: number;
};

export const deletePendingPayment = async (
  query: DeletePendingPaymentsParams
): Promise<DeletePendingPaymentsResponse['value']> => {
  try {
    const res = await apiClient.post<DeletePendingPaymentsResponse>(
      Endpoints.DeletedPayments,
      query
    );

    return res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
